import React, { useEffect, useState } from "react";
import { Input, Space, Form, Button, Modal, notification } from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { GrUpload } from "react-icons/gr";
import {
    Image,
    Select,
    TimePicker,
    Upload,
} from "antd";
import VideoRequest from "./VideoRequest";

const UpdateVideo = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false)
    const { id } = useParams();
    const [fileList, setFileList] = useState([])
    const navigate = useNavigate()
    const [previewOpen, setPreviewOpen] = useState(false);
    const [videoDetails, setVideoDetails] = useState({});
    const [previewImage, setPreviewImage] = useState("");
 const [submited, setSubmit] = useState(false);

    const getBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });


    useEffect(() => {
        const getVideoDetails = async () => {
            setLoading(true);
            try {
                const res = await VideoRequest.videoDetail(id);

                const videoData = res?.data?.data[0];
                console.log(videoData, 'video data')
                if (videoData) {
                    const mappedData = {
                        ...videoData,
                        status: videoData.status === 1 ? "1" : "0",
                    };
                    setVideoDetails(mappedData);
                    form.setFieldsValue({
                        title: mappedData.title,
                        status: mappedData.status,
                        description: mappedData.shortDescription,
                        videoUrl: mappedData.videoUrl,
                        orderBy: mappedData.orderBy.toString(),
                    });

                    if (mappedData.thumbnail) {
                        setFileList([{ url: mappedData.thumbnail, name: "Thumbnail Image" }]);
                    }
                }
            } catch (e) {
                console.log(e);
            } finally {
                setLoading(false);
            }
        };

        if (id) getVideoDetails();
    }, [id, form]);

    const update=()=>{
        setSubmit(true);
    
      }

    // Handle form submission
    const onFinish = (values) => {
        if(submited){
        setLoading(true);
        const formData = { ...values, id };

        console.log("Form Data being submitted:", formData);
        VideoRequest.updatevideo(formData)
            .then((res) => {
                console.log("API Response:", res);
                if (res.status === 200) {
                    notification["success"]({
                        message: "Video updated successfully",
                    });
                    navigate(-1, { state: { refresh: true } });
                } else {
                    notification["error"]({
                        message: "Something went wrong",
                    });
                }
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                notification["error"]({
                    message: "Failed",
                });
            });
        }
    };

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };

    const handleImageChange = ({ fileList: newFileList }) => {
        setFileList(newFileList);
        if (newFileList.length > 0) {

            const newFile = newFileList[0];
            setPreviewImage(newFile.url || newFile.preview);
        } else {
            setPreviewImage("");
        }
    }

 
    const uploadButton = (
        <button
            style={{
                border: 0,
                background: "none",
            }}
        >
            <GrUpload />
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </button>
    );

    const imageUpload = (file, name) => {
        // setLoading(true);

        const modifiedFile = new File([file], name, { type: file.type });
        let formData = new FormData();
        formData.append("file", modifiedFile);
        formData.append("fileName", name);

        VideoRequest.uploadImage(formData)
            .then((res) => {
                setLoading(false);
                form.setFieldsValue({
                    thumbnail: res?.data?.uploadDirectory,

                });
                console.log(res)
                if (res) {
                    return true;
                } else {
                    return false;
                }
            })
            .catch((e) => {
                setLoading(false);
                notification["error"]({
                    message: "File upload Failed",
                })
            }
            );
    };

    const props = {
        name: "file",
        multiple: false,
        beforeUpload: (file) => {

            imageUpload(file, file.name);
            return false;
        },
        onRemove() {
            setFileList([]);
        },
    };


    const handleChange = (value) => {
        console.log(`selected ${value}`);
    };

    const handleSubmit = () => {
        form.submit();
    };







    return (
        <>
            <section>
                <div className="Create-Category">
                    <Form.Item className=" submit-btn">
                        <Space>
                            <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
                                <ArrowLeftOutlined />
                            </Button>
                        </Space>
                    </Form.Item>
                    <h3>Update Video</h3>


                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                    >
                        {/* First Row */}
                        <div className="subscription">
                            <Form.Item
                                name="title"
                                label="Title"
                                className="subscription-plan"

                                rules={[{ required: true, message: "Please enter the User name!" },
                                {
                                    pattern: /^[A-Za-z\s]+$/,
                                    message: "Title can only contain letters and spaces.",
                                },
                                ]}
                            >
                                <Input size="large" placeholder="Enter Title" />
                            </Form.Item>

                            <Form.Item
                                name="description"
                                label="Description"
                                className="subscription-plan"
                                rules={[{ required: true, message: "Please enter description" },
                                {
                                    pattern: /^[A-Za-z\s]+$/,
                                    message: "Description can only contain letters and spaces.",
                                },
                                ]}
                            >
                                <Input size="large" placeholder="Enter Description" />
                            </Form.Item>
                        </div>
                        <div className="subscription">
                            <Form.Item
                                name="videoUrl"
                                label="Video Link"
                                className="subscription-plan"
                                rules={[{ required: true, message: "Please video link!" },
                                {
                                    type: 'url',
                                    message: "Please enter a valid URL!",
                                },
                                ]}
                            >
                                <Input size="large" placeholder="Enter YouTube Video Link" />
                            </Form.Item>
                            <Form.Item
                                label="Order By"
                                name="orderBy"
                                className="subscription-plan"
                                rules={[
                                    { required: true, message: "Please select order" },
                                ]}
                            >
                                <Select placeholder="Select order" style={{ marginTop: "0.5rem", width: "99%" }}>
                                    {[1, 2, 3, 4, 5].map((order) => (
                                        <Select.Option key={order} value={order.toString()}>
                                            {order}
                                        </Select.Option>
                                    ))}
                                </Select>
                                {/* <Select
                  placeholder="Select order"
                  style={{
                    marginTop: "0.5rem",
                  
                    width: "99%",
                  }}
                  onChange={handleChange}
                  options={[
                    {
                      value: "1",
                      label: "1",
                    },
                    {
                      value: "2",
                      label: "2",
                    },
                    {
                      value: "3",
                      label: "3",
                    },
                    {
                      value: "4",
                      label: "4",
                    },
                    {
                      value: "5",
                      label: "5",
                    },
                  
                  ]}
                /> */}
                            </Form.Item>

                        </div>

                        <div className="subscription" style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Form.Item
                                name="status"
                                label="Video Status"
                                className="subscription-plan"
                                rules={[{ required: true, message: "select video status!" }]}
                            >
                                <Select
                                    placeholder="Select The Category Status"
                                    style={{ marginTop: "0.5rem", width: "99%" }}
                                    options={[
                                        { value: "1", label: "Active" },
                                        { value: "0", label: "In Active" },
                                    ]}
                                />
                            </Form.Item>

                            <Form.Item
                                label="Thumbnail Images"
                                name="thumbnail"
                                className="subscription-plan"
                                // rules={[
                                //     {
                                //         required: true,
                                //         message: "Please upload the Thumbnail",
                                //     },
                                // ]}
                            >
                                <Upload
                                    {...props} maxCount={1}
                                    listType="picture-card"
                                    fileList={fileList}
                                    className="upload-Img-input"
                                    onPreview={handlePreview}
                                    onChange={handleImageChange}
                                >
                                    {fileList.length >= 8 ? null : uploadButton}
                                </Upload>
                                {previewImage && (
                                    <Image
                                        wrapperStyle={{
                                            display: "none",
                                        }}
                                        preview={{
                                            visible: previewOpen,
                                            onVisibleChange: (visible) => setPreviewOpen(visible),
                                            afterOpenChange: (visible) =>
                                                !visible && setPreviewImage(""),
                                        }}
                                        src={previewImage}
                                    />
                                )}
                            </Form.Item>


                            {/* <Form.Item
                                label="Update Video"
                                name="salonVideos"
                                className="subscription-plan"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please upload the salon videos",
                                    },
                                ]}
                            >
                                <Upload
                                    action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                                    listType="picture-card"
                                    fileList={videoList}
                                    className="salon-video-upload-input"
                                    onPreview={handleVideoPreview}
                                    onChange={handleVideoListChange}
                                    accept="video/*" // Restrict file type to videos
                                >
                                    {videoList.length >= 8 ? null : uploadButton}
                                </Upload>

                                <Modal
                                    visible={isVideoPreviewOpen}
                                    title={previewVideoTitle}
                                    footer={null}
                                    onCancel={() => setIsVideoPreviewOpen(false)}
                                >
                                    <video controls style={{ width: "100%" }}>
                                        <source src={previewVideoUrl} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </Modal>
                            </Form.Item> */}
                        </div>



                        <div className="bottom-button">
                            <div style={{ padding: "10px" }}>
                                <Button type="primary" htmlType="submit" loading={loading}  onClick={update}>
                                    Save & Proceed
                                    <span>
                                        <AiOutlineRight />
                                    </span>
                                </Button>
                            </div>
                        </div>
                    </Form>
                </div>
            </section>
        </>
    )
}

export default UpdateVideo